import COLLECTION_SUMMARY from './collection-summary'
import COLLECTION_PLAN_SETUP from './collection-plan-setup'
import LOAN_HISTORY from './loan-history'
import { PAYMENT_SCHEDULE, PAYMENT_AMOUNT } from './payment-schedule'
import WA_UPLOAD from './wa-upload'

export const LCS_DETAIL_LAYOUT_SETTING = {
  COLLECTION_SUMMARY,
  COLLECTION_PLAN_SETUP,
  LOAN_HISTORY,
  PAYMENT_SCHEDULE,
  PAYMENT_AMOUNT,
  WA_UPLOAD
}
